import React, { useEffect, useCallback, useState } from "react";
import ErrorHandler from "../../error-handler/ErrorHandler"
import {
  Container,
  Row,
  Col,
  Table,
  Modal,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';


const Reports = (props) => {
  const { t } = useTranslation();

  const ReportCard = ({ title, url }) => {
    return (
      <Col className='my-4' sm={4}>

        <div className="reportCard">
          <div className="reportTitle">
            <h2>{title}</h2>
          </div>
          <Link to={url}>
            <Button>{t("reports.display")}</Button>
          </Link>
        </div>
      </Col>
    )
  }
  return (
    <Container style={{
      textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
    }} className="viewSuper align-right">
      <Row>
        <Col lg={12}>
          <h2>
            {" "}
            <i class="fas fa-file-invoice pl-2"></i>{t("reports.reports")}
          </h2>
        </Col>
      </Row>
      <Row>
          <ReportCard title={t("reports.signature")} url="/reports/signature_reports" />
          <ReportCard title={t("reports.pendingSignatures")} url="/reports/pending_signature_reports" />
          <ReportCard title={t("reports.userActivity")} url="/reports/user_activity_reports" />
      </Row>
      <Row>
          <ReportCard title={t("reports.category")} url="/reports/category_reports" />
          <ReportCard title={t("reports.search")} url="/reports/search_reports" />
      </Row>
    </Container>
  );
};
const mapStateToProps = (state) => ({
  user: state.auth.user,
  privilege: state.auth.privilege,
});
export default connect(mapStateToProps)(Reports)
